import { render, staticRenderFns } from "./productPrice-list.vue?vue&type=template&id=0357ed6b&scoped=true"
import script from "./productPrice-list.vue?vue&type=script&lang=js"
export * from "./productPrice-list.vue?vue&type=script&lang=js"
import style0 from "./productPrice-list.vue?vue&type=style&index=0&id=0357ed6b&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0357ed6b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0357ed6b')) {
      api.createRecord('0357ed6b', component.options)
    } else {
      api.reload('0357ed6b', component.options)
    }
    module.hot.accept("./productPrice-list.vue?vue&type=template&id=0357ed6b&scoped=true", function () {
      api.rerender('0357ed6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/product-management/productPrice-management/productPrice-list.vue"
export default component.exports